import { useReducer, useRef } from "react";
import { checkboxInputDataReducer } from 'Components/Forms/FormReducers/CheckboxInputReducer';

var getVarValue = function (value) {
    if (typeof value === 'function') {
        return value();
    }
    else {
        return value;
    }
};

export function GetCheckboxInputObj ({ id, name, value, checkBoxes, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, inline }) {
    var checkInputObj = {
        type: 'checkbox',
        id: id,
        name: name,
        value: value,
        checkBoxes: checkBoxes,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            inline: inline
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            var checked = [];
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isChecked==true){
                    checked.push(ans[x].value);
                }
            }
            if(checked.length==0){
                return null;
            }
            else {
                return checked;
            }
            
        }
    };

    return useReducer(checkboxInputDataReducer, checkInputObj);
}

export function GetCompareCheckboxInputData (fieldName, fieldValue) {
    switch (fieldName) {
        case 'versions':
            return GetCheckboxInputObj({
                id: fieldName,
                name: fieldName,
                value: fieldValue,
                prevValue: null,
                checkBoxes: [],
                label: 'Manage Versions',
                description: '',
                title: '',
                placeholder: 'Manage Versions',
                required: false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
    }
}


